import { ReactNode, useState } from 'react';
import { clsx } from 'clsx';
import { HiChevronDown, HiXMark } from 'react-icons/hi2';
import AnchoredDialog from '../../../molecules/AnchoredDialog';
import Button from '../../../atoms/Button';
import FormGroup from '../../../atoms/FormGroup';
import { DataTableFilterKind } from '../../DataTable.types';
import { formatFilterValue } from '../../dataTableFilters';
import { DTB_POPUP_Z } from '../../popupZIndex';

interface IDataTableRangeFilterProps {
    header: string;
    kind: DataTableFilterKind;
    from: string;
    to: string;
    fromEditor: ReactNode;
    toEditor: ReactNode;
    loupe: boolean;
    onReset: () => void;
}

const DataTableRangeFilter = ({
    header,
    kind,
    from,
    to,
    fromEditor,
    toEditor,
    loupe,
    onReset,
}: IDataTableRangeFilterProps) => {
    const [opened, setOpened] = useState(false);
    const hasValue = from !== '' || to !== '';
    const text = [
        from && `От ${formatFilterValue(from, kind)}`,
        to && `${from ? 'до' : 'До'} ${formatFilterValue(to, kind)}`,
    ]
        .filter(Boolean)
        .join(' ');
    const fieldClassName = clsx('dtb__ffield', kind === 'date' && 'dtb__ffield--date');

    return (
        <span className="dtb__feditor dtb__frange-editor">
            <AnchoredDialog
                opened={opened}
                onClose={() => setOpened(false)}
                align="left"
                width={320}
                verticalOffset={6}
                zIndex={DTB_POPUP_Z}
                className="dtb__frange-panel"
                dropdownAria={{ 'aria-label': `Диапазон: ${header}` }}
                target={
                    <button
                        type="button"
                        className={clsx('dtb__frange-trigger', loupe && 'has-loupe', hasValue && 'has-value')}
                        aria-label={`Диапазон: ${header}, ${text ? text.toLocaleLowerCase('ru-RU') : 'не задан'}`}
                        title={text || 'От … до …'}
                        onClick={() => setOpened((prev) => !prev)}
                    >
                        <span>{text || 'От … до …'}</span>
                        <HiChevronDown aria-hidden />
                    </button>
                }
            >
                <div className="dtb__frange-fields" tabIndex={-1} data-autofocus>
                    <FormGroup label="От" size="sm">
                        <div className={fieldClassName}>{fromEditor}</div>
                    </FormGroup>
                    <FormGroup label="До" size="sm">
                        <div className={fieldClassName}>{toEditor}</div>
                    </FormGroup>
                    <div className="dtb__frange-actions">
                        <Button size="sm" variant="light" onClick={() => setOpened(false)}>
                            Готово
                        </Button>
                    </div>
                </div>
            </AnchoredDialog>
            {hasValue && (
                <button
                    type="button"
                    className="dtb__fclear"
                    aria-label={`Очистить диапазон: ${header.toLocaleLowerCase('ru-RU')}`}
                    title="Очистить диапазон"
                    onClick={onReset}
                >
                    <HiXMark aria-hidden />
                </button>
            )}
        </span>
    );
};

export default DataTableRangeFilter;
